import React, { PropsWithChildren } from "react";

// Nests a list of context providers so screens don't grow a wall of indentation as
// contexts are added. Providers are passed as elements (without children) so each one
// type-checks its own `value` prop at the call site; ContextsBootstrap clones them and
// threads the children through, outermost first.
export const ContextsBootstrap: React.FC<PropsWithChildren<{ contexts: React.ReactElement[] }>> = ({
  contexts,
  children,
}) => contexts.reduceRight((acc, provider) => React.cloneElement(provider, { children: acc }), children);
